/**
 * @description url 参数相关
 * @author wangfupeng
 */

import { each } from '../util'

// aio 全局变量
const D = window.D

/**
 * 截取当前页面的url参数
 * 过滤黑名单
 */
const URL_PARAMS = (function () {
    let obj = {}
    let blackList = ['debug', 'id']
    each(D.utils.decode().params, (key, value) => {
        if (blackList.indexOf(key) === -1) {
            obj[key] = value
        }
    })
    // 保证 lang cityid 直接透传
    if (obj.lang && obj.cityid) {
        // 多语言，lang，cityid 兜底逻辑
        let lang = obj.lang
        obj.cityid = parseInt(obj.cityid)
        let twReg = /^886500[0-9]{3}$/
        if (twReg.test(obj.cityid)) {
            lang = 'zh-TW'
        }

        obj.lang = lang
    }

    // 香港也有多语言如zh-HK,zh-CN
    if (!obj.lang && obj.cityid === 357) {
        obj.lang = 'zh-HK'
    }

    return obj
}())

export {
    URL_PARAMS
}
